import { HTMLAttributes, ReactNode } from 'react'

import './ListInfo.css'

interface Props extends HTMLAttributes<HTMLUListElement> {
  gap: number
  children: ReactNode
}
export const ListInfo = ({ gap, children, className, ...props }: Props) => {
  return (
    <ul
      className={`listInfo flex flex-col gap-[${gap}px] ${className}`}
      {...props}
    >
      {children}
    </ul>
  )
}
